var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20598_16180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7494 9.70859C15.7494 10.0544 15.4702 10.3336 15.1244 10.3336H14.491C14.3827 11.9586 13.0244 13.2503 11.3744 13.2503H10.6244L13.8535 15.8919C14.1202 16.1086 14.1619 16.5044 13.941 16.7711C13.816 16.9211 13.6369 17.0003 13.4577 17.0003C13.3202 17.0003 13.1785 16.9544 13.0619 16.8586L8.47852 13.1086C8.27435 12.9419 8.19518 12.6628 8.28685 12.4128C8.37435 12.1628 8.61185 11.9961 8.87435 11.9961H11.3744C12.3369 11.9961 13.1327 11.2669 13.2369 10.3294H8.87435C8.52852 10.3294 8.24935 10.0503 8.24935 9.70443C8.24935 9.35859 8.52852 9.07943 8.87435 9.07943H12.9327C12.5952 8.57526 12.0244 8.24609 11.3744 8.24609H8.87435C8.52852 8.24609 8.24935 7.96693 8.24935 7.62109C8.24935 7.27526 8.52852 6.99609 8.87435 6.99609H15.1244C15.4702 6.99609 15.7494 7.27526 15.7494 7.62109C15.7494 7.96693 15.4702 8.24609 15.1244 8.24609H13.8744C14.0619 8.49609 14.216 8.77943 14.3244 9.07943H15.1285C15.4744 9.07943 15.7535 9.35859 15.7535 9.70443L15.7494 9.70859Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20598_16180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(6.99951 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.e55364311d8a8d1c1e305178237efa83.svg";
export { ForwardRef as ReactComponent };